export default __webpack_public_path__ + "img/c9e29a2d7e21f650711fadc363ad3d19.svg";